import Vue from 'vue'
import CA, { computed } from '@vue/composition-api'
Vue.use(CA)

import { reactive } from '@vue/composition-api'
import router from '@iez/core/router'

export const state = reactive({
  isActive: false
})

export default () => {
  router.beforeEach((to, from, next) => {
    state.isActive = true
    next()
  })

  router.afterEach(() => {
    setTimeout(() => {
      state.isActive = false
    }, 800)
  })

  const methods = {
    set: ({ isActive }) => {
      state.isActive = isActive
    }
  }

  return {
    state,
    ...methods
  }
}
